module.exports = __webpack_public_path__ + "img/idea-vision-cooperate-icon.9ea2ccb3.svg";